"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSalesEvent = void 0;
const abstract_event_1 = require("../abstract.event");
class AbstractSalesEvent extends abstract_event_1.AbstractEvent {
    setGlobals(globals) {
        if (globals.currency && !this.config.currency) {
            this.config.currency = globals.currency;
        }
        if (globals.currency && Array.isArray(this.config.items)) {
            this.config.items = this.config.items.map(item => {
                if (!item.currency) {
                    item.currency = globals.currency;
                }
                return item;
            });
        }
        if (globals.brand && Array.isArray(this.config.items)) {
            this.config.items = this.config.items.map(item => {
                if (item.brand === undefined) {
                    item.brand = globals.brand;
                }
                return item;
            });
        }
        if (globals.affiliation && Object.prototype.hasOwnProperty.call(this.getData(), 'affiliation') && !this.config.affiliation) {
            this.config.affiliation = globals.affiliation;
        }
        if (globals.affiliation && Array.isArray(this.config.items)) {
            this.config.items = this.config.items.map(item => {
                if (item.affiliation === undefined) {
                    item.affiliation = globals.affiliation;
                }
                return item;
            });
        }
    }
}
exports.AbstractSalesEvent = AbstractSalesEvent;
//# sourceMappingURL=abstract-sales.event.js.map